(() => {
  let cartPending = false;
  const cartSelector = '[data-section-type="cart"]';

  async function changeQuantity(target, quantity) {
    const section = target.closest(cartSelector);
    if (!section || cartPending) return;
    const notice = section.querySelector('[data-pet-quantity-error]');
    const showError = (message) => {
      section.querySelectorAll('.quantity-selector__value').forEach(input => {
        input.value = input.dataset.currentValue;
      });
      if (!notice) return;
      notice.textContent = message;
      notice.hidden = false;
      notice.focus();
    };
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      showError(notice?.dataset.invalid);
      return;
    }
    cartPending = true;
    if (notice) notice.hidden = true;
    section.setAttribute('aria-busy', 'true');
    const controls = [...section.querySelectorAll('button:not(:disabled), input:not(:disabled)')];
    controls.forEach(control => { control.disabled = true; });
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: target.dataset.lineId, quantity })
      });
      if (!response.ok) throw new Error('Cart update failed');
      window.location.assign(window.routes.cartUrl);
    } catch (_) {
      showError(notice?.dataset.failed);
      cartPending = false;
      section.removeAttribute('aria-busy');
      controls.forEach(control => { control.disabled = false; });
    } finally {
      clearTimeout(timeout);
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');
    if (!target?.closest(cartSelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    changeQuantity(target, Number(target.dataset.quantity));
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target.matches('.quantity-selector__value') || !target.closest(cartSelector)) return;
    event.stopImmediatePropagation();
    changeQuantity(target, target.value.trim() === '' ? NaN : Number(target.value));
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches('.quantity-selector__value') && event.target.closest(cartSelector)) {
      event.preventDefault();
      event.target.blur();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (cartPending && event.target.closest(cartSelector)) event.preventDefault();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('form.product-form') || window.theme.cartType !== 'page') return;
    const notice = form.querySelector('[data-pet-cart-error]');
    const button = form.querySelector('.product-form__add-button');
    if (!notice || !button) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const body = new FormData(form);
    form.dataset.pending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    notice.hidden = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' }
      });
      if (!response.ok) {
        notice.querySelector('span').textContent = response.status === 422 ? notice.dataset.unavailable : notice.dataset.failed;
        notice.hidden = false;
        notice.focus();
        return;
      }
      window.location.assign(window.routes.cartUrl);
    } catch (_) {
      notice.querySelector('span').textContent = notice.dataset.failed;
      notice.hidden = false;
      notice.focus();
    } finally {
      form.dataset.pending = 'false';
      button.disabled = button.classList.contains('button--disabled');
      button.removeAttribute('aria-busy');
    }
  });
})();
